import { useNavigate, useRouterState } from '@tanstack/react-router';
import { useEffect } from 'react';

import { useAuth } from './useAuth';

export function useRequireAuth(): ReturnType<typeof useAuth> {
  const auth = useAuth();
  const navigate = useNavigate();
  const location = useRouterState({ select: (s) => s.location });

  useEffect(() => {
    if (auth.loading) return;
    if (!auth.session) {
      // Bounce to sign-in carrying the canonical, app-relative `next` so the
      // user returns here post-auth. Built from window.location (a plain
      // string) — TanStack's location.search is a parsed object, not a string.
      const nextPath = window.location.pathname + window.location.search + window.location.hash;
      void navigate({ to: '/auth/sign-in', search: { next: nextPath } });
      return;
    }
    if (auth.profile?.suspended_at && location.pathname !== '/suspended') {
      void navigate({ to: '/suspended' });
    }
  }, [auth.loading, auth.session, auth.profile, navigate, location.pathname]);

  return auth;
}
